import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import Color from 'color';

import useCountUp from '../useCountUp';
import FrameImage from './frame.svg';
import LogoImage from './worlds-logo.png';
import {
  Container,
  Diamont,
  Frame,
  FrameContainer,
  Logo,
  Time,
  Title,
} from './styles';

function CountUpLolWorlds({ data, styles }) {
  const haveTitle = !!data.title;

  const [hours, minutes, seconds] = useCountUp({
    status: data.status,
    time: data.time,
  });

  return (
    <>
      <Helmet>
        <link
          href="https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;700&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <Container>
        {haveTitle && (
          <Title
            style={{
              color: styles.title.color,
            }}
          >
            {data.title}
          </Title>
        )}
        <FrameContainer>
          <Frame src={FrameImage} alt="Frame" />
          <Time
            style={{
              color: styles.timer.color,
            }}
          >
            {`${hours}:${minutes}:${seconds}`}
          </Time>
        </FrameContainer>
        <Logo src={LogoImage} alt="Logo" />
        <Diamont>
          <svg
            width="24"
            height="29"
            viewBox="0 0 24 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 20.9717L8.06604 7.52832L15.5943 20.9717H0Z"
              fill={Color(styles.timer.color).darken(0.2)}
            />
            <path
              d="M23.6603 21.5094L15.5942 20.9717L11.8301 28.5L23.6603 21.5094Z"
              fill={Color(styles.timer.color).darken(0.4)}
            />
            <path
              d="M15.5943 20.9717H0L11.8302 28.5L15.5943 20.9717Z"
              fill={Color(styles.timer.color).darken(0.3)}
            />
            <path
              d="M23.6608 21.5093V6.99048L15.5947 20.9716L23.6608 21.5093Z"
              fill={Color(styles.timer.color).darken(0.25)}
            />
            <path
              d="M15.5947 20.9716L8.06641 7.52821L23.6607 6.99048L15.5947 20.9716Z"
              fill={Color(styles.timer.color).lighten(0.08)}
            />
            <path
              d="M23.6607 6.99057L11.8306 0L8.06641 7.5283L23.6607 6.99057Z"
              fill={Color(styles.timer.color).lighten(0.03)}
            />
            <path
              d="M8.06604 7.5283L11.8302 0L0 6.99057L8.06604 7.5283Z"
              fill={styles.timer.color}
            />
            <path
              d="M8.06604 7.52821L0 6.99048V20.9716L8.06604 7.52821Z"
              fill={Color(styles.timer.color).darken(0.1)}
            />
          </svg>
        </Diamont>
      </Container>
    </>
  );
}

CountUpLolWorlds.propTypes = {
  data: PropTypes.shape({
    status: PropTypes.string,
    time: PropTypes.arrayOf(PropTypes.number),
    title: PropTypes.string,
  }),
  styles: PropTypes.shape({
    timer: PropTypes.shape({
      color: PropTypes.string,
    }),
    title: PropTypes.shape({
      color: PropTypes.string,
    }),
  }),
};

CountUpLolWorlds.defaultProps = {
  data: {
    status: 'paused',
    time: [],
    title: 'Worlds League of legends',
  },
  styles: {
    timer: {
      color: '#1B32FF',
    },
    title: {
      color: '#FFFFFF',
    },
  },
};

export default CountUpLolWorlds;
